namespace TabAurous.Production {
    export namespace DismantlingReturnWIPService {
        export const baseUrl = 'Production/DismantlingReturnWIP';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<WIPTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/DismantlingReturnWIP/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>DismantlingReturnWIPService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
